let ErrorBag = require('./error-bag');
let MessageBag = require('../utils/message-bag');

class Form {
  /**
   * Create a new instance of the class
   *
   * @param {Object} client
   */
  constructor (client) {
    this.client = client;

    this.success = new MessageBag();
    this.errors = new ErrorBag();
  }

  /**
   * Submit the form as an HTTP POST request
   *
   * @param {String} uri
   * @param {Object} fields
   */
  post (uri, fields) {
    if (!fields.origin) {
      fields.origin = this.getRequestOrigin();
    }

    return this.client.post(uri, fields)
      .then(success => {
        this.handleSuccess(success);
        return Promise.resolve(success);
      })
      .catch(error => {
        this.handleError(error.response);
        return Promise.reject(error);
      });
  }

  /**
   * Handle the form success response
   *
   * @param {Object} data
   */
  handleSuccess ({data}) {
    this.success.put(
      'message',
      data.message || 'Thank you for reaching out! We will be in touch shortly!'
    );
  }

  /**
   * Handle the form error response
   *
   * @param {Object} response
   */
  handleError ({status, data}) {
    if (status && status >= 400 && status < 500) {
      this.errors.fill(data);

      if (typeof data._global !== 'undefined') {
        this.errors.setGlobalMessage(data._global);
      } else {
        this.errors.setGlobalMessage(
          'There were some errors with your input. Please correct them and try again.'
        );
      }

      return;
    }

    this.errors.fill({});

    this.errors.setGlobalMessage(
      'Something went wrong with the submission. Please try again.'
    );
  }

  /**
   * Get the form request origin URI
   *
   * @return {String}
   */
  getRequestOrigin () {
    return window.location.href;
  }
}

module.exports = Form;
